/* eslint-disable no-underscore-dangle */
class LSSuffix {
}
LSSuffix.getSuffix = () => {
    if (!LSSuffix.__defined__) {
        return '';
    }
    return LSSuffix.__suffix__;
};
LSSuffix.setSuffix = (localStorageSuffix) => {
    const suffixInput = (localStorageSuffix && `_${localStorageSuffix}`) || '';
    if (!LSSuffix.__defined__) {
        LSSuffix.__suffix__ = suffixInput;
        LSSuffix.__defined__ = true;
    }
    else if (LSSuffix.__suffix__ !== suffixInput) {
        throw new Error(`LSSuffix suffix is already set to ${LSSuffix.__suffix__}, cannot change it to ${suffixInput}`);
    }
    Object.freeze(LSSuffix);
};

export { LSSuffix as default };
